import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=4cf7aa5e&"
import script from "./Upload.vue?vue&type=script&lang=ts&"
export * from "./Upload.vue?vue&type=script&lang=ts&"
import style0 from "./Upload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports